import { apiRequest } from '../../api/http'
import type { NoonSalesImportCapability, NoonSalesImportJob, NoonSalesImportRowPage } from './types'

const CHANNELS_BASE = '/api/channels'

export function getNoonSalesImportCapability(accessToken: string): Promise<NoonSalesImportCapability> {
  return apiRequest<NoonSalesImportCapability>(CHANNELS_BASE, '/order-imports/noon-sales/capability', { accessToken })
}

export function uploadNoonSalesImport(
  accessToken: string,
  connectionId: number,
  file: File,
  sourceTimeZone?: string,
  partnerId?: string,
): Promise<NoonSalesImportJob> {
  const formData = new FormData()
  formData.append('file', file)
  if (sourceTimeZone !== undefined) formData.append('sourceTimeZone', sourceTimeZone)
  if (partnerId !== undefined) formData.append('partnerId', partnerId)
  return apiRequest<NoonSalesImportJob>(CHANNELS_BASE, `/${connectionId}/orders/imports/noon-sales`, {
    method: 'POST',
    formData,
    accessToken,
  })
}

export function getNoonSalesImportJob(accessToken: string, jobId: number): Promise<NoonSalesImportJob> {
  return apiRequest<NoonSalesImportJob>(CHANNELS_BASE, `/order-imports/noon-sales/${jobId}`, { accessToken })
}

export function getLatestNoonSalesImportJob(accessToken: string, connectionId: number): Promise<NoonSalesImportJob> {
  const query = new URLSearchParams({ connectionId: String(connectionId) })
  return apiRequest<NoonSalesImportJob>(CHANNELS_BASE, `/order-imports/noon-sales/latest?${query.toString()}`, { accessToken })
}

export function listNoonSalesImportRows(
  accessToken: string,
  jobId: number,
  page = 0,
  size = 20,
): Promise<NoonSalesImportRowPage> {
  const query = new URLSearchParams({ page: String(page), size: String(size) })
  return apiRequest<NoonSalesImportRowPage>(CHANNELS_BASE, `/order-imports/noon-sales/${jobId}/rows?${query.toString()}`, { accessToken })
}

export function cancelNoonSalesImport(accessToken: string, jobId: number): Promise<NoonSalesImportJob> {
  return apiRequest<NoonSalesImportJob>(CHANNELS_BASE, `/order-imports/noon-sales/${jobId}/cancel`, {
    method: 'POST',
    accessToken,
  })
}
